module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', [_vm._v("You can search the claims below to further filter your results:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight a-form-inputs p-compare-reserve__search-buttons"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.doSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.doReset
    }
  }, [_vm._v("Reset")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17f0b016!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/Search.vue
// module id = 1588
// module chunks = 0